import { render, staticRenderFns } from "./accessFormat.vue?vue&type=template&id=3da2f5dc&scoped=true"
import script from "./accessFormat.vue?vue&type=script&lang=js"
export * from "./accessFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2f5dc",
  null
  
)

export default component.exports